import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Functionality } from '../context/Functionality';
import { SiteHeader } from './navigation/SiteHeader';
import './navigation/siteHeader.css';

export default function Navbar() {
  const { token, logout, user, sessionReady } = useContext(Functionality);
  return <SiteHeader LinkComponent={Link} token={sessionReady ? token : null} logout={logout} isEmployee={user?.isEmployee} />;
}
